<template>
    <div class="container">
        <div class="reset-password">
            <h1 class="page_h1">重新設定密碼</h1>
            <div class="form f-row">
                <formInupt label="密碼" type="password"  maxlength="20" v-model="req.password" :error="error.password" />
                <formInupt label="再次輸入" type="password" maxlength="20" v-model="req.password_confirmation" />
                <div class="form_grp f-col@lg:auto align:r mg-t-12">
                    <button class="btn clr:primary" @click="onClick">修改</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
// @ is an alias to /src
import formInupt from '../../../components/form/input.vue'
import Validator from "../../../libs/Validator";
import Response from "../../../libs/Response";

export default {
    name: 'reset-password',
    components: {
        formInupt,
    },
    data(){
        return {
            req:{
                success_token:'',
                password:'',
                password_confirmation:'',
            },

            error:{
                password:'',
            }
        }
    },
    mounted() {
        const vm = this
        if(!vm.$route.params.hasOwnProperty('success_token')){
            vm.$router.replace({name:'forget_password', params:{}})
        }
        vm.req.success_token = vm.$route.params.success_token
    },
    methods:{
        async onClick(){
            const vm = this
            try{
                const validator = Validator.make(this.req, {
                    password: ['required', 'min:8', 'max:20', 'password', 'confirmed']
                })
                if (validator.fails()) {
                    console.log(validator._errors)
                    throw Response.create(validator.errors())
                }
                this.$store.commit('setLoadingStatus',true)
                const res = await vm.$axios.post('/api/reset_password', this.req);
                this.$store.commit('setLoadingStatus',false)
                vm.$router.push({name:'reset_complete',params:{created: true}});

            }catch (e) {
                console.log(e)
                this.$store.commit('setLoadingStatus',false)
                if(e.response.status === 510){
                    vm.$store.commit('setModalMessage','驗證碼已過時，請重新發送')
                    vm.$router.replace({name:'forget_password',params:{}});
                    return
                }

                vm.error = e.response.data
            }

        }
    },
}
</script>

<style lang="scss" scoped>
.router_link {
    font-size: 0.875rem;
}
</style>
